import React from 'react';
import type { FC } from 'react';
import { Box, Text, useAsync } from '@wix/cli-ui-kit';
import { useVeloClient, OnboardingState } from '@wix/velo-client';
import { match } from 'variant';
import { useSiteConfig } from '../../../model.js';
import { PlatformLink } from '../../PlatformLink/PlatformLink.js';
import { useDevEnvironment } from '../DevEnvironment.js';
import { useSiteDeploymentTopologyUpdater } from './useSiteDeploymentTopologyUpdater.js';

export const SiteDev: FC = () => {
  const { appId, siteId } = useSiteConfig();
  const { baseUrl, devArmTag } = useDevEnvironment();
  const veloClient = useVeloClient();

  const { status: gitHubOnboardingStatus } = useAsync(
    () => veloClient.getGitHubOnboardingStatus(appId),
    [appId]
  );

  useSiteDeploymentTopologyUpdater();

  return (
    <>
      <Text>Development environment ready</Text>
      <Box rowGap={1} marginY={1} flexDirection="column">
        <Text>Open the preview on:</Text>
        <Box paddingLeft={2} flexDirection="column">
          <PlatformLink url={baseUrl} platform="site" />
          <PlatformLink
            url={`https://manage.wix.com/dashboard/${siteId}?apps-override=${devArmTag}`}
            platform="dashboard"
          />
          {match(gitHubOnboardingStatus, {
            Success: ({ result }) =>
              result?.status === OnboardingState.GITHUB_ENABLED && (
                <PlatformLink
                  url={`https://vibe.wix.com/projects/${siteId}`}
                  platform="editor"
                />
              ),
            Error: () => null,
            Loading: () => null,
          })}
        </Box>
      </Box>
    </>
  );
};
